import type { PreVerificationPhase } from "@/api/onboarding-api.types"

/**
 * Whether a pre-verification is approved, discarded or cancelled. Those are shown for information only: they never
 * hold up Proceed and nothing about them is left to re-read.
 */
export function isFinishedPreVerification(phase: PreVerificationPhase): boolean {
  return phase === "Approved" || phase === "Discarded" || phase === "Cancelled"
}

/** Whether the phase's allowed decision may be left unset: Proceed goes ahead without it. */
export function hasOptionalDecision(phase: PreVerificationPhase): boolean {
  return phase === "NotSent"
}
